// Modules
import Common from "./modules/common";
import Animate from "./modules/animate";
import Header from "./modules/header";
import Lightbox from "./modules/lightbox";
import OB from "./modules/outdated-browser";

// Autoload modules
const modules = [Common, Animate, Header, Lightbox, OB];

modules.forEach((module) => {
  module.init();
});

// import local dependencies
import Router from "./utils/Router";
import templateHome from "./partials/template-home";
import pageTemplateDefault from "./partials/default";
import templatePortfolio from "./partials/template-portfolio";
import singlePost from "./partials/single-post";
import singleNews from "./partials/single-news";
import singleAwardsnews from "./partials/single-awardsnews";
import templateContacts from "./partials/template-contacts";
import templateServices from "./partials/template-services";
import pageSearch from "./partials/page-search";
import templateAbout from "./partials/template-about.js";
import templateAboutAsoc from "./partials/template-about.js";

// Populate Router instance with DOM routes
const routes = new Router({
  pageTemplateDefault,
  templateHome,
  templateAbout,
  templateAboutAsoc,
  templatePortfolio,
  singlePost,
  singleNews,
  singleAwardsnews,
  templateContacts,
  templateServices,
  pageSearch,
});

// Load Events
routes.loadEvents();
